import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { context } from '../../context/authContext';

export default function PrivateRoute({ requiredPermission }) {
  const { token, user } = useContext(context);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if(Array.isArray(user.rol)){
    const module = user.rol.find((mod) => location.pathname.startsWith(mod.ruta));

    if (!module || !requiredPermission.some(permission => module.permiso.includes(permission))){
      return <Navigate to="/unauthorized" replace />
    }else{
      return <Outlet />}
  }
}
